import { render, staticRenderFns } from "./MYP103M01.vue?vue&type=template&id=1012301b&"
import script from "./MYP103M01.vue?vue&type=script&lang=js&"
export * from "./MYP103M01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports